export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Plans';
export const TEAM_NAME = 'jet-chronos-team';
